module.exports = __webpack_public_path__ + "static/flags/AL-d7d216025f0719556ad6200acbcdec4f.gif";